import { TextSnippet as CsvIcon } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import type { Dayjs } from "dayjs";
import { useSnackbar } from "notistack";
import type { FC } from "react";
import { useState } from "react";
import CancelButton from "../../components/cancelButton/CancelButton";
import DownloadFileButton from "../../components/downloadFileButton/DownloadFileButton";
import LabelledCheckbox from "../../components/labelledCheckbox/LabelledCheckbox";
import StaticMonthPicker from "../../components/staticMonthPicker/StaticMonthPicker";
import dayjs from "../../dayjs";

interface Props {
  readonly title: string;
  readonly filename: string;
  readonly downloadErrorMessage: string;
  readonly open: boolean;
  readonly onClose: () => void;
  onDownload: (fromMonth: string, toMonth: string, showHistorical: boolean) => Promise<Blob>;
}

const CsvExportDialog: FC<Props> = ({ title, filename, downloadErrorMessage, open, onClose, onDownload }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [fromMonth, setFromMonth] = useState(dayjs().subtract(1, "month").startOf("month"));
  const [toMonth, setToMonth] = useState(dayjs().add(11, "months").endOf("months"));
  const handleFromMonthChange = (v: Dayjs | null) => {
    if (v) {
      setFromMonth(v);
    }
  };
  const handleToMonthChange = (v: Dayjs | null) => {
    if (v) {
      setToMonth(v);
    }
  };
  const [showHistorical, setShowHistorical] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid size={6}>
            <StaticMonthPicker label="Data początkowa" value={fromMonth} onChange={handleFromMonthChange} />
          </Grid>
          <Grid size={6}>
            <StaticMonthPicker label="Data końcowa" value={toMonth} onChange={handleToMonthChange} />
          </Grid>
          <Grid size={12}>
            <LabelledCheckbox
              label="Uwzględniaj historyczne zamówienia"
              checked={showHistorical}
              onChange={setShowHistorical}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose} />
        <DownloadFileButton
          buttonText="Pobierz CSV"
          startIcon={<CsvIcon />}
          options={[
            {
              name: "Pobierz CSV",
              apiDefinition: () =>
                onDownload(fromMonth.format("YYYY-MM"), toMonth.format("YYYY-MM"), showHistorical).then((f) => {
                  onClose();
                  return f;
                }),
            },
          ]}
          onError={() => enqueueSnackbar(downloadErrorMessage, { variant: "error" })}
          filename={filename}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CsvExportDialog;
